"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = void 0;
function assertUnreachable(val, failureMessage) {
    throw new Error(failureMessage !== null && failureMessage !== void 0 ? failureMessage : "Received a value which should not exist: ".concat(JSON.stringify(val)));
}
exports.assertUnreachable = assertUnreachable;
